import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5","key":"svg-0"}],["path",{"d":"M10 9l4 0","key":"svg-1"}]]

/**
 * IconTemperature
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGVtcGVyYXR1cmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDEzLjVhNCA0IDAgMSAwIDQgMHYtOC41YTIgMiAwIDAgMCAtNCAwdjguNSIgLz4KICA8cGF0aCBkPSJNMTAgOWw0IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/temperature
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTemperature = createReactComponent('outline', 'temperature', 'Temperature', __iconNode);

export default IconTemperature;